import { IFastFiltersUserSchema } from 'shared/repositories/monolith-python/entities/schemas/FastFiltersUserSchema';

export const userReducer = (state: IFastFiltersUserSchema) => state || null;
